import { useNavigate } from 'react-router-dom';

export const useHistoryNav = () => {
	const history = useNavigate();
	return history;
};
